module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plans"
  }, [_c('h1', {
    staticClass: "pageHeading"
  }, [_c('b', [_vm._v("PLANS")]), _vm._v(" & "), _c('b', [_vm._v("PRINCING")])]), _vm._v(" "), _c('div', {
    staticClass: "cardSection"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 padding-minus"
  }, [_c('a', {
    attrs: {
      "href": "#topic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cardHeader"
  }, [_c('h1', [_vm._v("Startup")])]), _vm._v(" "), _c('div', {
    staticClass: "cardBody"
  }, [_c('div', {
    staticClass: "amountSection"
  }, [_c('div', {
    staticClass: "left amount"
  }, [_c('h4', [_vm._v("$8."), _c('sub', [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "right amount"
  }, [_c('h4', [_vm._v("12")]), _vm._v(" "), _c('p', [_vm._v("targets")])])]), _vm._v(" "), _c('div', {
    staticClass: "cardBodyHeader"
  }, [_c('p', [_vm._v("FEATURES")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("User")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("2 Users")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("Email Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("SMS Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardFooter"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_c('b', [_vm._v("PPRICE")]), _vm._v(" (Yearly)")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("$99.99")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 padding-minus"
  }, [_c('a', {
    staticClass: "business",
    attrs: {
      "href": "#topic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cardHeader"
  }, [_c('h1', [_vm._v("Business")]), _vm._v(" "), _c('p', [_vm._v("MOST POPULAR")])]), _vm._v(" "), _c('div', {
    staticClass: "cardBody"
  }, [_c('div', {
    staticClass: "amountSection"
  }, [_c('div', {
    staticClass: "left amount"
  }, [_c('h4', [_vm._v("$34."), _c('sub', [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "right amount"
  }, [_c('h4', [_vm._v("40")]), _vm._v(" "), _c('p', [_vm._v("targets")])])]), _vm._v(" "), _c('div', {
    staticClass: "cardBodyHeader"
  }, [_c('p', [_vm._v("FEATURES")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("User")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("2 Users")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("Email Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("SMS Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardFooter"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_c('b', [_vm._v("PPRICE")]), _vm._v(" (Yearly)")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("$339.99")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 padding-minus"
  }, [_c('a', {
    attrs: {
      "href": "#topic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "cardHeader"
  }, [_c('h1', [_vm._v("Enterprise")])]), _vm._v(" "), _c('div', {
    staticClass: "cardBody"
  }, [_c('div', {
    staticClass: "amountSection"
  }, [_c('div', {
    staticClass: "left amount"
  }, [_c('h4', [_vm._v("$79."), _c('sub', [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "right amount"
  }, [_c('h4', [_vm._v("100")]), _vm._v(" "), _c('p', [_vm._v("targets")])])]), _vm._v(" "), _c('div', {
    staticClass: "cardBodyHeader"
  }, [_c('p', [_vm._v("FEATURES")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("User")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("2 Users")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("Email Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_vm._v("SMS Alerts")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("Unlimited")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardFooter"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "featureHeadind"
  }, [_c('b', [_vm._v("PPRICE")]), _vm._v(" (Yearly)")]), _vm._v(" "), _c('span', {
    staticClass: "featureDetail"
  }, [_vm._v("$949.99")])])])])])])])])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c57747c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Plans.vue